import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormBuilderLabel } from '../../interfaces/formData.interface';
import { ValidationError } from '../../interfaces/validation-error.interface';
import { Hint } from '../hint/hint.component';

@Component({
  selector: 'dg-fb-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnChanges {
  @Input() group?: UntypedFormGroup;
  @Input() labelFor?: string;
  @Input() rows?: number;
  @Input() classes?: string;
  @Input() control?: string;
  @Input() showValidation = false;
  @Input() label?: FormBuilderLabel;
  @Input() validators?: ValidationError[];
  @Input() placeholder?: string;
  @Input() chrLimit?: number;
  @Input() hint?: Hint;

  refreshValidation$ = new Subject();

  defaultLimit = 200;

  theLength = 0;

  ngOnChanges(): void {
    if (Number(this.chrLimit) === 0 || this.chrLimit === null) {
      this.chrLimit = this.defaultLimit;
    }

    this.theLength =
      (this.chrLimit as number) -
      (this.group?.controls[this.control as string].value?.length || 0);

    if (this.theLength) {
      (
        this.group?.controls[this.control as string] as UntypedFormControl
      ).valueChanges.subscribe((value) => {
        this.theLength = (this.chrLimit as number) - value?.length;
      });
    }
  }

  onBlur() {
    this.showValidation = true;
    this.refreshValidation$.next(true);
  }
}
